/** Helper for evaluating registry identifier and itemKind values */
export const evaluate = (f: string | ((v: string) => string), v: string) =>
  typeof f === "function" ? f(v) : f;
